<template functional>
    <!--   页脚 start     -->
    <div class="footer">
        <div class="wrap">
            <div class="web-site-box">
                <div class="web-site-item">赣州产控集团官方网站</div>
                <div class="web-site-item">赣州产控集团云平台</div>
                <div class="web-site-item">赣州产控集团智慧园区平台</div>
            </div>
            <div class="footer-info-box">
                <div class="footer-img-box">
<!--                    <img class="icon-footer-dzjg" src="@/assets/images/icon-footer-dzjg.png">-->
<!--                    <img class="icon-footer-zfwz" src="@/assets/images/icon-footer-zfwz.png">-->
                    <img class="logo" src="@/assets/images/logo.png" style="background-color: #fff;width:273px;height: 60px; padding: 10px" >
                </div>
                <div class="footer-info-container-left">
                    <div class="footer-info-left-item"><router-link to="/">网站首页</router-link></div>
                    <div class="footer-info-left-item"><router-link to="/EnquiryNotices">询价报价</router-link></div>
                    <div class="footer-info-left-item"><router-link to="/inviteBid">平台招投标</router-link></div>
                    <div class="footer-info-left-item"><router-link to="/publicBid">公开招标公告</router-link></div>
                    <div class="footer-info-left-item"><router-link to="/postscript">澄清补遗</router-link></div>
                    <div class="footer-info-left-item"><router-link to="/bidAnnounce">中标公示</router-link></div>
                    <div class="footer-info-left-item"><router-link to="/misconduct">不良行为处理</router-link></div>
                    <div class="footer-info-left-item"><router-link to="/inviteSuppliers">招募供应商</router-link></div>
                    <div class="footer-info-left-item"><router-link to="/complain">投诉意见箱</router-link></div>
                </div>
                <div class="footer-info-container-right">
                    <div class="footer-info-right-item">版权所有：赣州产控集团</div>
                    <div class="footer-info-right-item">联系地址：江西省赣州市赣州开发区香江大道88号</div>
                    <div class="footer-info-right-item">电话：0797-8682232</div>
<!--                    <div class="footer-info-right-item">传真：123-45613136</div>-->
<!--                    <div class="footer-info-right-item">赣ICP备20121345号-1 </div>-->
<!--                    <div class="footer-info-right-item"><img class="icon-footer-jh" src="@/assets/images/icon-footer-jh.png">赣公网安备98710202001009号</div>-->
<!--                    <div class="footer-info-right-item">政府网站标识码：2901060853</div>-->
                </div>
            </div>
        </div>
    </div>
    <!--   页脚 end     -->
</template>
<script>
export default {};
</script>
<style lang="less" scoped>
    .wrap{
        width: 1200px;
        margin: 0 auto;
        /*background-color: red;*/
    }
    @media(max-width:960px){
        .wrap{
            width: 100%;
            margin: 0 auto;
        }
    }

    /*    页脚*/
    .footer{
        height: 250px;
        background-color: #2b579e;
        color: #fff;
        box-sizing: border-box;
        padding: 30px;
        .web-site-box{
            /*display: flex;*/
            display: none;
            justify-content: space-between;
            align-items: center;
            .web-site-item{
                width: 380px;
                height: 40px;
                display: flex;
                align-items: center;
                justify-content: center;
                background-color: #1a4b99;
                font-size: 20px;
                cursor: pointer;
            }
        }
        .footer-info-box{
            margin-top: 20px;
            display: flex;
            .footer-img-box{
                width: 227px;
                height: 130px;
                align-items: center;
                display: flex;
                justify-content: space-between;
                .icon-footer-dzjg{
                    width: 56px;
                    height: 68px;
                }
                .icon-footer-zfwz{
                    width: 110px;
                    height: 55px;
                }
            }
            @media(max-width:960px){
                .footer-img-box{
                    display: none;
                }
            }
            .footer-info-container-left{
                width: 373px;
                height: 130px;
                background-color: #1a4b99;
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                font-size: 14px;
                padding: 20px 20px 20px 37px;
                margin-left: 50px;
                .footer-info-left-item{
                    width: 105px;
                    display: inline-flex;
                    justify-content: left;
                    align-items: center;
                    cursor: pointer;
                    color: #fff;
                    a{
                        color: #fff;
                    }
                }
            }
            .footer-info-container-right{
                flex: 1;
                height: 130px;
                background-color: #1a4b99;
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                font-size: 14px;
                padding: 17px 23px;
                margin-left: 20px;
                .footer-info-right-item{
                    display: inline-flex;
                    align-items: center;
                }
                .icon-footer-jh{
                    width: 18px;
                    height: 20px;
                    margin-right: 10px;
                }
            }
        }
    }
    @media(max-width:960px){
        .footer{
            height: auto;
            padding: 15px;
            .web-site-box{
                flex-wrap: wrap;
                .web-site-item{
                    margin-bottom: 10px;
                    font-size: 16px;
                    height: 32px;
                    width: 100%;
                }
            }
            .footer-info-box{
                flex-wrap: wrap;
                margin-top: 0px;
                .footer-info-container-left{
                    margin-left: 0;
                    padding: 15px;
                    height: auto;
                    width: 100%;
                    .footer-info-left-item{
                        width: 98px;
                    }
                }
                .footer-info-container-right{
                    margin-left: 0;
                    margin-top: 10px;
                    padding: 15px;
                    height: 100px;
                }
            }
        }

        .footer-img-box{
            display: none;
        }
    }
</style>
